import { gql } from 'src/__generated__';

export const UPDATE_PERSONAL_DETAILS = gql(`
  mutation UpdatePersonalDetails(
    $personalDetailsInput: UpdatePersonalDetailsInput!
    $currentLocationInput: UpdateCurrentLocation2Input!
    $zone: Zone!
  ) {
    updatePersonalDetails(input: $personalDetailsInput) {
      viewer {
        ...UserDetailsFragment
      }
    }
    updateCurrentLocation2(input: $currentLocationInput) {
      ... on UpdateCurrentLocation2Success {
        viewer {
          _id
          currentLocation2(zone: $zone) {
            countryCode
            description
            kind
            id
            shortDescription
          }
        }
      }
      ... on UpdateCurrentLocation2Failure {
        error {
          message
        }
      }
    }
  }
`);
